import backgroundImage from "../../images/landing_background.jpg";

const styles = (theme) => {
  return {
    root: {
      background: `url(${backgroundImage})`,
      backgroundSize: "cover",
      display: "flex",
      flexFlow: "nowrap column",
      alignItems: "center",
      flexGrow: 1,
      height: "100%",
    },
    title: {
      color: "#444",
      padding: 12,
    },
    loadingTitle: {
      color: "white",
      padding: 12
    },
    paper: {
      width: "33%",
      minWidth: 300,
      padding: theme.spacing(4),
      margin: 150,
      backgroundColor: "rgba(255,255,255,0.4)",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
        margin: "10% 0",
      },
    },
    logo: {
      marginTop: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        width: "60%",
        marginTop: "100px",
      },
    },
    button: {
      margin: theme.spacing(4, 1),
      fontSize: 17,
      height: 55,
      fontWeight: "bold",
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(1),
      },
    },
  };
};

export default styles;
